import $ from "jquery";

window.hideSpinner = function(){ console.log('hideSpinner'); $('.games-spinner-modal').fadeOut() }

window.startGame = function(zappelinGame) {
  console.log("startGame.");
  if (window.applicationCache && window.applicationCache.status !== window.applicationCache.UNCACHED ) {
    console.log("nohide!")
    applicationCache.addEventListener('noupdate', hideSpinner);
    applicationCache.addEventListener('noupdate', zappelinGame);
    applicationCache.addEventListener('cached', hideSpinner);
    applicationCache.addEventListener('cached', zappelinGame);
    applicationCache.addEventListener('error', hideSpinner);
    applicationCache.addEventListener('error', zappelinGame);
  } else {
    console.log("hide!")
    $(document).ready(hideSpinner);
    $(document).ready(zappelinGame);
  }
}

$(document).ready(function() {
  // reload page if cache manifest is updated
  if (!!window.applicationCache) {
    applicationCache.addEventListener('updateready', function() {
      if (applicationCache.status == applicationCache.UPDATEREADY) {
        applicationCache.swapCache();
        location.reload();
      }
    });
  }

  // Open game links into a properly formatted popup. Borrowed from zapp
  $('a.game').on('click', function(event) {
    event.preventDefault();

    var width       = $(this).data('width');
    var height      = $(this).data('height');
    var scrollbars  = $(this).data('scrollbars');

    window.open(this.href, '_blank', 'toolbar=no, status=no, location=no, menubar=no, resizable=yes, width='+width+', height='+height+', scrollbars='+scrollbars);
  });

});
